import * as effects from 'redux-saga/effects';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import {
	isEmptyArray,
	isNullOrUndefinedOrEmptyArray,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';
import {
	addGroupChannels,
	addGroupChannelsSTT,
	addGroupChannelsTPP,
	addUserChannels,
	addUserChannelsSTT,
	addUserChannelsTPP,
	getAllMedias,
	getAllMediasFailed,
	getAllMediasSucceed,
	getChannelsFromUser,
	getChannelsFromUserFailed,
	getChannelsFromUserSucceed,
	getChannelsFromUserSTT,
	getChannelsFromUserSTTFailed,
	getChannelsFromUserSTTSucceed,
	getChannelsFromUserTPP,
	getChannelsFromUserTPPFailed,
	getChannelsFromUserTPPSucceed,
	getGroupsAndUsersFromChannel,
	getGroupsAndUsersFromChannelFailed,
	getGroupsAndUsersFromChannelSucceed,
	getGroupsAndUsersFromChannelSTT,
	getGroupsAndUsersFromChannelSTTFailed,
	getGroupsAndUsersFromChannelSTTSucceed,
	getGroupsAndUsersFromChannelTPP,
	getGroupsAndUsersFromChannelTPPFailed,
	getGroupsAndUsersFromChannelTPPSucceed,
	getMedia,
	setGroupChannels,
	setGroupChannelsSTT,
	setGroupChannelsTPP,
	setLoadingChannelsFromUser,
	setLoadingGroupsAndUsersFromChannel,
	setLoadingMedias,
	setUserChannels,
	setUserChannelsSTT,
	setUserChannelsTPP,
	addGroupChannelsMT,
	getChannelsFromUserMT,
	getGroupsFromChannelMT,
	setGroupChannelsMT,
	getGroupsFromChannelMTSucceed,
	getGroupsFromChannelMTFailed,
	getChannelsFromUserMTSucceed,
	setUserChannelsSucceed,
	setUserChannelsFailed,
	setUserChannelsSTTSucceed,
	setUserChannelsSTTFailed,
	setUserChannelsTPPSucceed,
	setUserChannelsTPPFailed,
} from './Actions';
import { IAppsManagementActionTypes } from './Types';
import { setError, setSuccessMessage } from '../NotificationBar/Actions';

// Constante pour le nombre maximum de tentatives
const MAX_RETRY_ATTEMPTS = 3;

function* handleAddGroupChannels(action: ReturnType<typeof addGroupChannels>) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addGroupChannels, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddGroupChannelsMT(
	action: ReturnType<typeof addGroupChannelsMT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addGroupChannelsMT, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddUserChannels(action: ReturnType<typeof addUserChannels>) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addUserChannels, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddGroupChannelsTPP(
	action: ReturnType<typeof addGroupChannelsTPP>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addGroupChannelsTPP, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddGroupChannelsSTT(
	action: ReturnType<typeof addGroupChannelsSTT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addGroupChannelsSTT, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddUserChannelsSTT(
	action: ReturnType<typeof addUserChannelsSTT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addUserChannelsSTT, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleAddUserChannelsTPP(
	action: ReturnType<typeof addUserChannelsTPP>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addUserChannelsTPP, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed');
	}
}

function* handleGetAllMedias(_action: ReturnType<typeof getAllMedias>) {
	const backend = Backend.getInstance();
	yield effects.put(setLoadingMedias(true));

	for (let attempt = 1; attempt <= MAX_RETRY_ATTEMPTS; attempt++) {
		try {
			// @ts-ignore
			const res = yield effects.apply(backend, backend.getAllMedias);
			
			if (!isNullOrUndefinedOrEmptyArray(res)) {
				yield effects.put(getAllMediasSucceed(res));
				yield effects.put(setLoadingMedias(false));
				return; // Succès, on sort de la fonction
			} else {
				if (!isEmptyArray(res)) {
					throw new Error('no media received');
				} else {
					throw new Error('unexpected error');
				}
			}
		} catch (err) {
			Logger.warn({ err, attempt }, `Failed getting all medias (attempt ${attempt}/${MAX_RETRY_ATTEMPTS})`);
			
			if (attempt === MAX_RETRY_ATTEMPTS) {
				// Si c'est la dernière tentative, on envoie l'erreur
				yield effects.put(getAllMediasFailed('Failed getting all medias after multiple attempts'));
				yield effects.put(setLoadingMedias(false));
			} else {
				// On continue directement avec la prochaine tentative
				console.log(`Retrying... Attempt ${attempt + 1}/${MAX_RETRY_ATTEMPTS}`);
			}
		}
	}
}

function* handleGetChannelsFromUser(
	action: ReturnType<typeof getChannelsFromUser>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingChannelsFromUser(true));
	try {
		const res = yield effects.apply(backend, backend.getChannelsFromUser, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(getChannelsFromUserSucceed(res.channels === null ? [] : res.channels));
	} catch (err) {
		Logger.warn({ err }, 'Failed getting channels from user or group');
		yield effects.put(getChannelsFromUserFailed('Failed getting channels from user or group'));
	} finally {
		yield effects.put(setLoadingChannelsFromUser(false));
	}
}

function* handleGetChannelsFromUserMT(
	action: ReturnType<typeof getChannelsFromUserMT>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingChannelsFromUser(true));
	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getChannelsFromUserMT,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getChannelsFromUserMTSucceed(
				res.channels === null ? [] : res.channels
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting channels from group');
		yield effects.put(
			getChannelsFromUserFailed('Failed getting channels from group')
		);
	}
}

function* handleGetGroupsAndUsersFromChannel(
	action: ReturnType<typeof getGroupsAndUsersFromChannel>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingGroupsAndUsersFromChannel(true));

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getGroupsAndUsersFromChannel,
			[action.payload[0], action.payload[1]] as any
		);

		yield effects.put(
			getGroupsAndUsersFromChannelSucceed(
				res.users === null ? [] : res.users,
				res.groups === null ? [] : res.groups
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting groups and users from channel');
		yield effects.put(
			getGroupsAndUsersFromChannelFailed(
				'Failed getting groups and users from channel'
			)
		);
	}
}

function* handleGetChannelsFromUserTPP(
	action: ReturnType<typeof getChannelsFromUserTPP>
) {
	const backend = Backend.getInstance();
	yield effects.put(setLoadingChannelsFromUser(true));
	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getChannelsFromUserTPP,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getChannelsFromUserTPPSucceed(
				res.channels === null ? [] : res.channels
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting channels from user or group');
		yield effects.put(
			getChannelsFromUserTPPFailed(
				'Failed getting channels from user or group'
			)
		);
	}
}

function* handleGetGroupsAndUsersFromChannelTPP(
	action: ReturnType<typeof getGroupsAndUsersFromChannelTPP>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingGroupsAndUsersFromChannel(true));

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getGroupsAndUsersFromChannelTPP,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getGroupsAndUsersFromChannelTPPSucceed(
				res.users === null ? [] : res.users,
				res.groups === null ? [] : res.groups
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting groups and users from channel');
		yield effects.put(
			getGroupsAndUsersFromChannelTPPFailed(
				'Failed getting groups and users from channel'
			)
		);
	}
}

function* handleGetGroupsFromChannelMT(
	action: ReturnType<typeof getGroupsFromChannelMT>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingGroupsAndUsersFromChannel(true));

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getGroupsFromChannelMT,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getGroupsFromChannelMTSucceed(
				res.users === null ? [] : res.users,
				res.groups === null ? [] : res.groups
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting groups and users from channel');
		yield effects.put(
			getGroupsFromChannelMTFailed(
				'Failed getting groups and users from channel'
			)
		);
	}
}

function* handleGetChannelsFromUserSTT(
	action: ReturnType<typeof getChannelsFromUserSTT>
) {
	const backend = Backend.getInstance();
	yield effects.put(setLoadingChannelsFromUser(true));
	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getChannelsFromUserSTT,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getChannelsFromUserSTTSucceed(
				res.channels === null ? [] : res.channels
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting channels from user or group');
		yield effects.put(
			getChannelsFromUserSTTFailed(
				'Failed getting channels from user or group'
			)
		);
	}
}

function* handleGetGroupsAndUsersFromChannelSTT(
	action: ReturnType<typeof getGroupsAndUsersFromChannelSTT>
) {
	const backend = Backend.getInstance();

	yield effects.put(setLoadingGroupsAndUsersFromChannel(true));

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getGroupsAndUsersFromChannelSTT,
			[action.payload[0], action.payload[1]] as any
		);
		yield effects.put(
			getGroupsAndUsersFromChannelSTTSucceed(
				res.users === null ? [] : res.users,
				res.groups === null ? [] : res.groups
			)
		);
	} catch (err) {
		Logger.warn({ err }, 'Failed getting groups and users from channel');
		yield effects.put(
			getGroupsAndUsersFromChannelSTTFailed(
				'Failed getting groups and users from channel'
			)
		);
	}
}

function* handleGetMedia(action: ReturnType<typeof getMedia>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getMedia, [
			action.payload,
		] as any);
		if (!isNullOrUndefinedOrEmptyArray(res.media)) {
			yield effects.put(getAllMediasSucceed(res.media));
		} else {
			if (!isEmptyArray(res.media)) {
				yield effects.put(getAllMediasFailed('no media received'));
			} else {
				if (!isNullOrUndefinedOrEmptyString(res.errorMsg)) {
					yield effects.put(getAllMediasFailed(res.errorMsg));
				} else {
					yield effects.put(getAllMediasFailed('unexpected error'));
				}
			}
		}
	} catch (err) {
		Logger.warn({ err }, 'Failed getting all medias');
		yield effects.put(getAllMediasFailed('Failed getting all medias'));
	}
}

function* handleSetGroupChannels(action: ReturnType<typeof setGroupChannels>) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setGroupChannels, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(setSuccessMessage('Group channels updated successfully'));
	} catch (err) {
		Logger.warn({ err }, 'Failed');
		yield effects.put(setError(new Error('Failed to update group channels')));
	}
}

function* handleSetUserChannels(action: ReturnType<typeof setUserChannels>) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setUserChannels, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		console.log(err);
		yield effects.put(setUserChannelsFailed(err.message));
		yield effects.put(setError(new Error('Failed to update channels')));
	} finally {
		yield effects.put(setUserChannelsSucceed());
		yield effects.put(setSuccessMessage('Channels updated successfully'));
	}
}

function* handleSetGroupChannelsTPP(
	action: ReturnType<typeof setGroupChannelsTPP>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setGroupChannelsTPP, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(setSuccessMessage('Group TPP channels updated successfully'));
	} catch (err) {
		Logger.warn({ err }, 'Failed');
		yield effects.put(setError(new Error('Failed to update group TPP channels')));
	}
}

function* handleSetUserChannelsTPP(
	action: ReturnType<typeof setUserChannelsTPP>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setUserChannelsTPP, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		yield effects.put(setUserChannelsTPPFailed(err.message));
		yield effects.put(setError(new Error('Failed to update TPP channels')));
	} finally {
		yield effects.put(setUserChannelsTPPSucceed());
		yield effects.put(setSuccessMessage('TPP channels updated successfully'));
	}
}

function* handleSetGroupChannelsSTT(
	action: ReturnType<typeof setGroupChannelsSTT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setGroupChannelsSTT, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(setSuccessMessage('Group STT channels updated successfully'));
	} catch (err) {
		Logger.warn({ err }, 'Failed');
		yield effects.put(setError(new Error('Failed to update group STT channels')));
	}
}

function* handleSetGroupChannelsMT(
	action: ReturnType<typeof setGroupChannelsMT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setGroupChannelsMT, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
			action.payload[3],
			action.payload[4],
		] as any);
		yield effects.put(setSuccessMessage('Group MyTrack channels updated successfully'));
	} catch (err) {
		Logger.warn({ err }, 'Failed');
		yield effects.put(setError(new Error('Failed to update group MyTrack channels')));
	}
}

function* handleSetUserChannelsSTT(
	action: ReturnType<typeof setUserChannelsSTT>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.setUserChannelsSTT, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		yield effects.put(setUserChannelsSTTFailed(err.message));
		yield effects.put(setError(new Error('Failed to update STT channels')));
	} finally {
		yield effects.put(setUserChannelsSTTSucceed());
		yield effects.put(setSuccessMessage('STT channels updated successfully'));
	}
}

function* watchAddGroupChannels() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_GROUP_CHANNELS,
		handleAddGroupChannels
	);
}
function* watchAddUserChannels() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_USER_CHANNELS,
		handleAddUserChannels
	);
}
function* watchAddGroupChannelsSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_GROUP_CHANNELS_STT,
		handleAddGroupChannelsSTT
	);
}
function* watchAddUserChannelsSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_USER_CHANNELS_STT,
		handleAddUserChannelsSTT
	);
}
function* watchAddGroupChannelsTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_GROUP_CHANNELS_TPP,
		handleAddGroupChannelsTPP
	);
}
function* watchAddUserChannelsTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_USER_CHANNELS_TPP,
		handleAddUserChannelsTPP
	);
}
function* watchGetAllMedias() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_ALL_MEDIAS,
		handleGetAllMedias
	);
}
function* watchGetChannelsFromUser() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER,
		handleGetChannelsFromUser
	);
}
function* watchGetGroupsAndUsersFromChannel() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL,
		handleGetGroupsAndUsersFromChannel
	);
}
function* watchGetChannelsFromUserSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT,
		handleGetChannelsFromUserSTT
	);
}
function* watchGetGroupsAndUsersFromChannelSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT,
		handleGetGroupsAndUsersFromChannelSTT
	);
}
function* watchGetChannelsFromUserTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP,
		handleGetChannelsFromUserTPP
	);
}
function* watchGetGroupsAndUsersFromChannelTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP,
		handleGetGroupsAndUsersFromChannelTPP
	);
}
function* watchGetMedia() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_MEDIA,
		handleGetMedia
	);
}
function* watchSetGroupChannels() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_GROUP_CHANNELS,
		handleSetGroupChannels
	);
}
function* watchSetUserChannels() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_USER_CHANNELS,
		handleSetUserChannels
	);
}
function* watchSetGroupChannelsTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_GROUP_CHANNELS_TPP,
		handleSetGroupChannelsTPP
	);
}
function* watchSetUserChannelsTPP() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_USER_CHANNELS_TPP,
		handleSetUserChannelsTPP
	);
}
function* watchSetGroupChannelsSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_GROUP_CHANNELS_STT,
		handleSetGroupChannelsSTT
	);
}
function* watchSetUserChannelsSTT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_USER_CHANNELS_STT,
		handleSetUserChannelsSTT
	);
}

function* watchAddGroupChannelsMT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.ADD_GROUP_CHANNELS_MT,
		handleAddGroupChannelsMT
	);
}
function* watchGetChannelsFromUserMT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT,
		handleGetChannelsFromUserMT
	);
}
function* watchGetGroupsFromChannelMT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT,
		handleGetGroupsFromChannelMT
	);
}
function* watchSetGroupChannelsMT() {
	yield effects.takeLatest(
		IAppsManagementActionTypes.SET_USER_CHANNELS_MT,
		handleSetGroupChannelsMT
	);
}

export function* AppsManagementSaga(): Generator<
	effects.AllEffect<effects.ForkEffect<void>>,
	void
> {
	yield effects.all([effects.fork(watchAddGroupChannels)]);
	yield effects.all([effects.fork(watchAddGroupChannelsMT)]);
	yield effects.all([effects.fork(watchAddGroupChannelsSTT)]);
	yield effects.all([effects.fork(watchAddGroupChannelsTPP)]);
	yield effects.all([effects.fork(watchAddUserChannels)]);
	yield effects.all([effects.fork(watchAddUserChannelsSTT)]);
	yield effects.all([effects.fork(watchAddUserChannelsTPP)]);
	yield effects.all([effects.fork(watchGetAllMedias)]);
	yield effects.all([effects.fork(watchGetChannelsFromUser)]);
	yield effects.all([effects.fork(watchGetChannelsFromUserMT)]);
	yield effects.all([effects.fork(watchGetChannelsFromUserSTT)]);
	yield effects.all([effects.fork(watchGetChannelsFromUserTPP)]);
	yield effects.all([effects.fork(watchGetGroupsAndUsersFromChannel)]);
	yield effects.all([effects.fork(watchGetGroupsAndUsersFromChannelSTT)]);
	yield effects.all([effects.fork(watchGetGroupsAndUsersFromChannelTPP)]);
	yield effects.all([effects.fork(watchGetGroupsFromChannelMT)]);
	yield effects.all([effects.fork(watchGetMedia)]);
	yield effects.all([effects.fork(watchSetGroupChannels)]);
	yield effects.all([effects.fork(watchSetGroupChannelsMT)]);
	yield effects.all([effects.fork(watchSetGroupChannelsSTT)]);
	yield effects.all([effects.fork(watchSetGroupChannelsTPP)]);
	yield effects.all([effects.fork(watchSetUserChannels)]);
	yield effects.all([effects.fork(watchSetUserChannelsSTT)]);
	yield effects.all([effects.fork(watchSetUserChannelsTPP)]);
}
